module.exports = __webpack_public_path__ + "static/media/Circo2024_07.6f68ac22.webp";